import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';

const WalletTransactions = ({ transactions = [], loading }) => {
  const [visibleTransactions, setVisibleTransactions] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  // Inicializa las transacciones cuando los datos cambian
  useEffect(() => {
    if (transactions.length > 0) {
      setVisibleTransactions(transactions.slice(0, 10)); // Mostrar las primeras 10
      setHasMore(transactions.length > 10);
    }
  }, [transactions]);

  // Cargar más transacciones cuando el usuario haga scroll
  const fetchMoreData = () => {
    setTimeout(() => {
      const nextTransactions = transactions.slice(
        visibleTransactions.length,
        visibleTransactions.length + 10
      );

      setVisibleTransactions(prev => [...prev, ...nextTransactions]);

      if (visibleTransactions.length + 10 >= transactions.length) {
        setHasMore(false);
      }
    }, 500); // Simula carga
  };

  return (
    <Card sx={{ mt: 3 }}>
      <CardContent>
        <Typography variant="h6">Historial de Transacciones</Typography>
        <Divider sx={{ my: 2 }} />

        {loading ? (
          <CircularProgress sx={{ display: 'block', mx: 'auto', my: 2 }} />
        ) : transactions.length === 0 ? (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ textAlign: 'center', mt: 2 }}
          >
            No hay transacciones recientes.
          </Typography>
        ) : (
          <InfiniteScroll
            dataLength={visibleTransactions.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <CircularProgress sx={{ display: 'block', mx: 'auto', my: 2 }} />
            }
          >
            <List>
              {visibleTransactions.map(tx => (
                <ListItem key={tx._id}>
                  <ListItemText
                    primary={`${tx.type === 'credit' ? '+' : '-'}${tx.amount.toFixed(2)} €`}
                    secondary={`${tx.description} - ${new Date(tx.date).toLocaleString()}`}
                  />
                </ListItem>
              ))}
            </List>
          </InfiniteScroll>
        )}

        {!hasMore && visibleTransactions.length > 0 && (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ textAlign: 'center', mt: 2 }}
          >
            No hay más transacciones.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default WalletTransactions;
